import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: true,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: {
        translation: {
          title: "FIDIA",
          link: "https://docs.google.com/document/d/10imHBwip4tEAfb4eY5Ta3jmlKwgD28zaqzc3h8mqAx0/view",
          description: {
            part1: "Here",
            part2: "you can download a zipper file containing excel templates to fill in. CAUTION, do not modify anything in the downloaded documents except, of course, filling in the records in the appropriate fields, you can change the business company code according to your needs.",
            part3: "With the following tool, it is possible to store within a server the three types of excel files (FIDIA_XX.xlsx; CUSTOMER_XX.xlsx; MATERIAL_XX.xlsx) that are provided on the application.",
            part4: "Not all excel files are accepted there are rules that must be followed, they can be viewed ",
            part5: "here",
            part6: ".",
            part7: "WARNING! When you receive a response that some of the values entered are wrong, there is a need to specify that except for them the remaining records in the excel file were correctly loaded into the server! Then at the next upload you must remove the correct records and edit the wrong ones from the excel file."
          },
          dropfiles: "You are dropping some files.",
          dragfiles: {
            part1: "Drop here the",
            part2: "files or click to browse. Upload it at least one and maximum three.",
            part3: ".xlsx or .xls"
          },
          istelemntTitle: "This is the list of items you entered:",
          delete: "Delete",
          alertSuccess: "The files are correctly uploaded.",
          tableTitle: "This table contains all the wrong values",
          allert: {
            part1: "Please upload at least one file .xls or .xlsx",
            part2: "The files are correctly uploaded.",
            part3: "ERROR: \nAn error was made in entering some values. Check the generated table containing an error report by scrolling down the page.",
            part4: "Only three file can be uploaded at a time.",
            part5: "The file name should be in the form FIDIA/CUSTOMER/MATERIAL_XX.xlsx or .xls",
            parts6: "There is a generic error",
            networkError: "There was an error connecting to the server. Please check the URL of the server and make sure the server is running. If you have modified the file, delete it and upload it again, or refresh the page."
          },
          errors: {
            "DB_SequelizeDatabaseError": "There is a database error when trying to update or insert records. Please check the data in your Excel file.",
            "header_error": "There is an error in the file headers. Please check the template and the headers in your Excel file: ",
            "Date_validation_error": "There is an error in the file dates. Please ensure that all years in the 'Invoice Date' column are greater than or equal to the latest year already present in the database for this file",
            "read_ECONNRESET": "There is a connection error with the database. Please check the database connection.",
            "connect_ECONNREFUSED": "There is a connection error with the database. Please check the database connection.",
            "DB_SequelizeConnectionRefusedError": "There is a connection error with the database. Please check the database connection",
            "generic": "An unexpected error occurred. Please try again later or contact support if the problem persists.",
            "SequelizeConnectionRefusedError": "The database connection has been refused. Please check the database connection.",
            "Not_All_File": "Not all files were uploaded successfully. Files uploaded: {{files_done}} - Files not uploaded: {{files_errors}}",
            "download_file": "An error occurred while downloading the file"
          }

        }
      },
      it: {
        translation: {
          title: "FIDIA",
          link: "https://docs.google.com/document/d/1g3ZsryhAstdE33TnKrVXZDbEgMvU9qanIyYccDnbJEU/view",
          description: {
            part1: "Qui",
            part2: "puoi scaricare un file zip contenente i template dei documenti da mandare. ATTENZIONE, non modificare il contenuto e la forma dei documenti scaricati, ovviamente ad esclusione dei campi da riempire opportunatamente, puoi cambiare il business company name in base alle tue esigenze",
            part3: "Con il seguente tool è possibile memorizzare all'interno di un server i tre tipi di file excel (FIDIA_XX.xlsx; CUSTOMER_XX.xlsx; MATERIAL_XX.xlsx) che vengono forni sull'applicativo.",
            part4: "Non sono accettati tutti i file excel vi sono delle regole da dover rispettare, sono visualizzabili ",
            part5: "qui",
            part6: ".",
            part7: "ATTENZIONE! Quando si riceve risposta che alcuni valori inseriti sono sbagliati, c'è da specificare che ad esclusione dei medesimi i restanti record presenti nel file excel sono stati correttamente caricati nel server! Quindi al caricamento successivo bisogna togliere i record corretti e modificare quelli sbagliati dal file excel."

          },
          dropfiles: "Stai rilasciando dei file.",
          dragfiles: {
            part1: "Lascia qui",
            part2: "i file o cliccami per cercarli. Carica almeno un file e massimo tre.",
            part3: ".xlsx o .xls"

          },
          istelemntTitle: "Questa è la lista degli elementi inseriti:",
          delete: "Elimina",
          alertSuccess: "I file sono stati correttamenti caricati.",
          tableTitle: "Questa tabella contiene tutti i valori sbagliati",
          allert: {
            part1: "Carica almeno un file .xls o .xlsx",
            part2: "I file sono stati caricati correttamente.",
            part3: "ERRORE: \n Alcuni campi forniti contengono degli errori. Controlla la tabella generata contenente un resoconto degli errori scorrendo la pagina.",
            part4: "Possono essere caricati solo tre file alla volta.",
            part5: "Il nome del file dovrebbe essere nella forma FIDIA/CUSTOMER/MATERIAL_XX.xlsx o .xls",
            parts6: "Questo è un errore generico: ",
            networkError: "Si è verificato un errore di connessione al server. Controlla l'URL del server e assicurati che sia in esecuzione. Se hai modificato il file, eliminalo e caricalo di nuovo, oppure aggiorna la pagina."
          },
          errors: {
            "DB_SequelizeDatabaseError": "Si è verificato un errore del database durante il tentativo di aggiornare o inserire i record. Controlla i dati nel tuo file Excel.",
            "header_error": "C'è un errore nelle intestazioni del file. Verifica il modello e le intestazioni nel tuo file Excel: ",
            "Date_validation_error": "C'è un errore nelle date del file. Assicurati che tutti gli anni nella colonna 'Invoice Date' siano maggiori o uguali all'anno più recente già presente nel database per questo file.",
            "read_ECONNRESET": "Si è verificato un errore di connessione con il database. Controlla la connessione al database.",
            "connect_ECONNREFUSED": "Si è verificato un errore di connessione con il database. Controlla la connessione al database.",
            "DB_SequelizeConnectionRefusedError:": "Si è verificato un errore di connessione con il database. Controlla la connessione al database.",
            "generic": "Si è verificato un errore imprevisto. Riprova più tardi o contatta il supporto se il problema persiste.",
            "SequelizeConnectionRefusedError": "La connessione al database è stata rifiutata. Controlla la connessione al database.",
            "Not_All_File": "Non tutti i file sono stati caricati correttamente, file caricati: {{files_done}} - file non caricati: {{files_errors}}",
            "download_file": " Si è verificato un errore durante il download del file"
          }

        }
      }

    }
  });

/**
 * Internationalization object for handling translations.
 * @type {object}
 */
export default i18n;
